import React from 'react';
import { Link } from 'react-router-dom';
import useSeo from '../lib/useSeo';
import { Statement, StatementRow } from '../components/Statement';
import { Label, Mullions } from '../components/System';

function NotFound() {
  useSeo({
    title: 'Page not found',
    description: 'The page you were looking for does not exist.',
    noindex: true,
  });

  return (
    <main className="relative w-full">
      <section className="relative bg-limestone">
        <Mullions />
        <div className="shell">
          <div className="grid-12 relative items-center gap-y-10 pb-28 pt-16 lg:min-h-[640px]">
            <div className="col-span-4 lg:col-span-7">
              <Label className="mb-5">Error 404</Label>
              <h1 className="type-h1">This query returned no rows.</h1>
              <p className="type-lead mt-6 text-glass">
                The page you asked for doesn&rsquo;t exist — or it moved. Head back to the overview and start again.
              </p>
              <div className="mt-9 flex flex-col gap-3 sm:flex-row">
                <Link to="/" className="btn-primary">Back to home</Link>
                <Link to="/documentation" className="btn-outline">Read the docs</Link>
              </div>
            </div>
            <div className="col-span-4 lg:col-span-4 lg:col-start-9">
              <Statement title="Receipt">
                <div className="border-t border-wall/70">
                  <StatementRow label="Rows returned" value="0" />
                  <StatementRow label="Status" value="404" />
                </div>
              </Statement>
            </div>
          </div>
        </div>
      </section>
    </main>
  );
}

export default NotFound;
